import script from "./DetailsBookingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsBookingForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__